import React from 'react'
import { Link } from 'react-router-dom'

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <h1 className="text-4xl font-bold mb-2">404</h1>
      <p className="text-xl mb-2">Strona nie została znaleziona</p>
      <p className="text-slate-500 text-sm mb-6">Jeśli szukałeś Regulaminu, znajdziesz go poniżej.</p>
      <div className="space-x-4">
        <Link to="/" className="px-6 py-2 bg-home-a text-white rounded-lg hover:bg-opacity-90 transition">Wróć do strony głównej</Link>
        <Link to="/terms" className="px-6 py-2 bg-slate-200 text-slate-800 rounded-lg hover:bg-slate-300 transition">Regulamin</Link>
      </div>
    </div>
  )
}

export default NotFound 